module.exports = __webpack_public_path__ + "static/media/JarakFizikalYangSelamatKetikaBeriadahatauBersenam.bdb590cb.jpg";